export default {
  AUTH_DATA_DASHBOARD: 'Resumen',
  AUTH_USER_ADM: 'Gestión del sistema',
  AUTH_SYS_APP_CONFIG: 'Configuración',
  AUTH_CUSTOMER_SERVICE_ADM: 'Atención al cliente',
  AUTH_MERCHANT_MANAGER: 'Gestión de comercios',
  AUTH_SETTLEMENT_MANAGER: 'Transacciones de cobro y pago',
  AUTH_SETTLEMENT_BALANCE: 'Gestión de saldos',
  AUTH_SETTLEMENT_RECHARGE: 'Recargar',
  AUTH_SETTLEMENT_WITHDRAW: 'Retirar',
  AUTH_SETTLEMENT_STATISTICS_FILE_DOWN: 'Resumen de transacciones',
  AUTH_PAYMENT_LINK: 'Enlaces de pago',
  AUTH_DISBURSEMENT_APPROVE: 'Auditoría y aprobación de pagos',
  AUTH_DISBURSEMENT_PAGE: 'Pago de bajo valor',
  AUTH_DISBURSEMENT_CHECK: 'Verificación de pagos',
  AUTH_DISBURSEMENT_CONFIRM: 'Creación de pagos',
  AUTH_PAYMENT_PAGE: 'Página de pago',
  AUTH_SETTLEMENT_BALANCE_DETAIL: 'Detalles de saldo',
  AUTH_SETTLEMENT_TRANSFER: 'Transferencia entre comercios asociados',
  AUTH_TRANSACTION_PAYIN: 'Cobros / Pay-in',
  AUTH_TRANSACTION_PAYOUT: 'Pagos / Payouts',
  AUTH_TRANSACTION_SUMMARY: 'Resumen de transacciones',
  AUTH_CUSTOMER_SERVICE_PAYIN: 'Consulta de cobros (Pay-in)',
  AUTH_CUSTOMER_SERVICE_PAYOUT: 'Consulta de pagos (Payout)',
  AUTH_CUSTOMER_SERVICE_TICKET: 'Tickets de atención al cliente',
  AUTH_ROLE_ADM: 'Gestión de roles',
  AUTH_MERCHANT_STORE_CREATE: 'Crear código QR de tienda',
  AUTH_MERCHANT_STORE_DOWNLOAD: 'Descargar código QR de tienda',
  AUTH_VA_COLLECTION_ADM: 'Cobros por VA (Cuenta Virtual)',
  AUTH_LARGE_AMOUNT_KEY: 'Enviar pagos',
  AUTH_FINANCIALS_SETTING: 'Configuración de fondos',
  QRCODE_KEY: 'Código de cobro / QR',
  AUTH_QRCODE_ADM: 'Lista de códigos de cobro',
  AUTH_LARGE_AMOUNT: 'Pago de alto valor',
  AUTH_LARGE_CREATE_DISBURSEMENT: 'Beneficiario de alto valor',
  DASHBOARD_KEY: 'Resumen',
  FINANCIAL_KEY: 'Gestión de fondos',
  TRANSACTION_KEY: 'Gestión de transacciones',
  CUSTSER_KEY: 'Atención al cliente',
  PAYMENT_LINK_KEY: 'Enlaces de pago',
  SEND_PAYMENT_KEY: 'Enviar pagos',
  PAYMENT_PAGE_KEY: 'Página de pago',
  DEVELOPER_KEY: 'Desarrollador',
  SYS_KEY: 'Gestión del sistema',
  MCH_STORE_KEY: 'Código QR de tienda',
  VA_COLLECTION_KEY: 'Cobros por VA (Cuenta Virtual)',
  AUTH_TRANSACTION_REFUND: 'Transacciones de reembolso',
  AUTH_PAYMENT_REFUND: 'Botón de transacciones de reembolso',
  AUTH_CUSTOMER_SERVICE_REFUND: 'Consulta de transacciones de reembolso',
  SPLIT_KEY: 'Plataforma',
  AUTH_SPLIT_PAYMENT: 'Transacciones de reparto de fondos',
  AUTH_SPLIT_MERCHANT: 'Comercio'
}
